import {
  SANCTION_ASSOCIATE_FETCH_REQUEST,
  SANCTION_ASSOCIATE_FETCH_REQUEST_SUCCESS,
  SANCTION_ASSOCIATE_FETCH_REQUEST_FAILURE,
  SANCTION_ASSOCIATE_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const sanctionAssociateReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case SANCTION_ASSOCIATE_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SANCTION_ASSOCIATE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: {
          ...state.payload,
          [`${action.data.id}`]: action.data,
        },
        errors: {},
      });

    case SANCTION_ASSOCIATE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
        pagination: {},
      });

    case SANCTION_ASSOCIATE_CLEAN_REQUEST:
      return Object.assign({}, state, {
        loading: false,
        payload: [],
        errors: {},
      });

    default:
      return state;
  }
};

export default sanctionAssociateReducer;
